import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@teem/environments/environment';

@Component({
  selector: 'view-billing-subscription',
  templateUrl: './view-billing-subscription.component.html',
  styleUrls: ['./view-billing-subscription.component.scss']
})
export class ViewBillingSubscriptionComponent implements OnInit {

  @Input('invoiceDetail') invoiceDetail: any;
  @Output() changeTab: EventEmitter<any> = new EventEmitter();
  basicInfo: any;
  cardChargedValue: any;
  constructor(public activeModal: NgbActiveModal,) { }

  ngOnInit(): void {
    this.basicInfo = (window as any).userInfo;
    this.cardChargedValue = this.invoiceDetail?.card_type + ' ' + this.invoiceDetail?.card_id;
  }

  saveAsPdf() {
		(window as any).open(`${environment.baseUrl}/subscription-invoice/${this.invoiceDetail.uuid}/${(window as any).LOCALE}`, '_blank');	
	}

}
